const STATUS_BODY_LABEL_MAP = {
    новая: 'Новая',
    'в работе': 'В работе',
    выполнена: 'Выполнено',
    принята: 'Принята',
    'в архиве': 'Архив',
};

export function stripEndOfDayDeadlineTime(text) {
    if (!text) return text;
    return String(text).replace(/(\d{2}\.\d{2}\.\d{4}) 23:59/g, '$1');
}

export function parseTaskStatusFromNotifBody(body) {
    const text = String(body || '').trim();
    if (!text) return '';
    const match = text.match(/статус:\s*(.+?)\.?\s*$/i);
    if (!match) return '';
    const raw = match[1].trim().replace(/\.$/, '');
    return STATUS_BODY_LABEL_MAP[raw.toLowerCase()] || raw;
}

export function formatTaskStatusChangedText({ actorName = '', body = '' } = {}) {
    const actor = String(actorName || '').trim();
    const statusLabel = parseTaskStatusFromNotifBody(body);
    if (statusLabel) {
        return actor
            ? `${actor} изменил(а) статус на «${statusLabel}»`
            : `Статус изменён на «${statusLabel}»`;
    }
    const trimmedBody = stripEndOfDayDeadlineTime(String(body || '').trim());
    if (trimmedBody) return trimmedBody;
    return actor ? `${actor} изменил(а) статус` : 'Изменён статус задачи';
}
